import styled from 'styled-components'

export const Wrap = styled.div`
  display: flex;
  font-size: 30px;

  & > :not(:last-child) {
    margin-right: 5px;
  }
`

